/* eslint-disable import/no-anonymous-default-export */

// Cores e estilos padrão do sistema
const COLORS = {
  PRIMARY: '#1b3663',
  SECONDARY: '#4a90e2',
  SUCCESS: '#52c41a',
  WARNING: '#faad14',
  ERROR: '#f5222d',
  INFO: '#1890ff',
  
  GRAY: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  
  WHITE: '#ffffff',
  BLACK: '#000000',
};

// Text colors
const tc1 = { color: COLORS.PRIMARY };
const tc2 = { color: COLORS.SECONDARY };
const tc3 = { color: COLORS.WHITE };

// Background colors
const bc1 = { backgroundColor: COLORS.PRIMARY };
const bc2 = { backgroundColor: COLORS.SECONDARY };
const bc3 = { backgroundColor: COLORS.WHITE };
const bc4 = { backgroundColor: COLORS.GRAY[100] };
const bc5 = { backgroundColor: COLORS.GRAY[200] };
const bc6 = { backgroundColor: COLORS.GRAY[300] };
const bc7 = { backgroundColor: COLORS.GRAY[50] };

// Border colors
const bdc1 = { borderColor: COLORS.PRIMARY };
const bdc2 = { borderColor: COLORS.SECONDARY };

export default {
  COLORS,
  tc1,
  tc2,
  tc3,
  bc1,
  bc2,
  bc3,
  bc4,
  bc5,
  bc6,
  bc7,
  bdc1,
  bdc2,
};


